import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Info } from '../Info';
import { InfoItem } from '../../../../pages/ServiceManagement';

interface GeneralInfoProps {
  serviceName: string;
  connectionType: string;
  servicePrice: number | string;
  isDaily: boolean;
}

export const GeneralInfo: FC<GeneralInfoProps> = ({ serviceName, connectionType, servicePrice, isDaily }) => {
  const { t } = useTranslation();

  const generalInfo: InfoItem[] = [
    {
      label: t('serviceManagement.service'),
      value: serviceName,
    },
    connectionType
      ? {
          label: t('serviceManagement.connectionType'),
          value: connectionType,
        }
      : {},
    {
      label: typeof servicePrice === 'string' && servicePrice.length === 0 ? '' : t('serviceManagement.price'),
      value: `${servicePrice} ${isDaily ? t('services.uahPerDay') : t('services.uahPerMonth')}`,
    },
  ];
  return <Info infoItems={generalInfo} title={t('serviceManagement.generalInformation')} />;
};
